import { Hover, Select, DefaultXRControllers, ARCanvas } from '@react-three/xr'
import { Html, Loader, Text } from "@react-three/drei"
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { Canvas, useLoader, useFrame, useThree, extend } from 'react-three-fiber'
import React, { useRef, useCallback, Suspense, useState, useMemo, useEffect } from 'react'
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import * as THREE from 'three';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import './App.css';
import { Controls, useControl } from 'react-three-gui';
import { a, config } from 'react-spring/three';
import { Vector3 } from 'three/build/three.module'

// Extend will make OrbitControls available as a JSX element called orbitControls for us to use.
extend({ OrbitControls });

function Camera(props) {
  const ref = useRef()
  const { camera, setDefaultCamera } = useThree()
  // This makes sure that size-related calculations are proper
  // Every call to useThree will return this camera instead of the default camera 
  useEffect(() => void setDefaultCamera(ref.current), [])
  return <perspectiveCamera ref={camera} {...props} />
}

const CameraControls = () => {
  // Get a reference to the Three.js Camera, and the canvas html element.
  // We need these to setup the OrbitControls class.
  // https://threejs.org/docs/#examples/en/controls/OrbitControls

  const {
    camera,
    gl: { domElement },
  } = useThree();

  // Ref to the controls, so that we can update them on every frame using useFrame
  const controls = useRef();
  useFrame((state) => controls.current.update());
  return (
    <orbitControls
      ref={controls}
      args={[camera, domElement]}
      enableZoom={true}
      maxAzimuthAngle={Math.PI / 4}
      maxPolarAngle={Math.PI}
      minAzimuthAngle={-Math.PI / 4}
      minPolarAngle={0}
    />
  );
};

export function Model2(props) {

  // const mesh = useRef()
  // const { gl, camera } = useThree()

  // useEffect(() => {
  //   const cam = gl.xr.isPresenting ? gl.xr.getCamera(camera) : camera
  //   cam.translateZ(50);
  //   mesh.current.add(cam)
  //   cam.translateZ(50);
  //   return () => mesh.current.remove(cam)
  // }, [gl.xr.isPresenting, gl.xr, camera, mesh])

  // const controls = useRef();
  // useFrame((state) => controls.current.update());
  //const { nodes, scene, animations } = useLoader(GLTFLoader, "/wp-content/plugins/ar-webgl-wp/app/build/GLTF_Torre/torre.gltf", draco("/draco-gltf/"));
  //const { nodes, scene, animations } = useLoader(GLTFLoader, "/wp-content/plugins/ar-webgl-wp/app/build/murotorre.glb");
  //const { nodes, scene, animations } = useLoader(GLTFLoader, "./TorreFin/MuroExtRev.gltf");
  const { nodes, scene, animations } = useLoader(GLTFLoader, props.modelo);
  //return scene ? <primitive object={scene} position={[posX, posY, posZ]} scale={[0.2, 0.2, 0.2]} /> : null;
  return scene ? <primitive object={scene} position-x={props.posicion[0]} position-y={props.posicion[1]} position-z={props.posicion[2]} scale={[props.escala[0], props.escala[1], props.escala[2]]} /> : null;

}


function App() {

  const [content, setContent] = useState([]);

  useEffect(() => {

    let self = this;
    fetch("https://turismoarroyomolinos.madrid/wp-json/wp/v2/molino-doble?filter[orderby]=date&order=asc", { method: "GET" })
      .then(res => res.json())
      .then(data => {
        let contentAPI = []
        console.log("fetch data from server");
        console.log(data);

        data.forEach(element => {
          let elementAPI = {
            modelo: element.modelo,
            posicion: element.posicion.split(","),
            escala: element.escala.split(",")
          };
          contentAPI.push(elementAPI);
        });
        setContent(contentAPI);
        console.log(content);
      })
      .catch(console.log);
  }, []);

  return (
    <React.Fragment >
      <ambientLight />
      <CameraControls />
      <pointLight position={[1, 1, 1]} />
      <Suspense fallback={<Html center>
        <Loader />
      </Html>}>
        {content[0] && <Model2 modelo={content[0].modelo} posicion={content[0].posicion} escala={content[0].escala} />}
      </Suspense>
      <DefaultXRControllers />
    </React.Fragment>
  )
}

function createCanvas() {
  return (
    <div id="wglmap">
      <ARCanvas sRGB camera={{ position: [0, 0, 10] }}>
        {/* <Camera position={[0, 0, 55]} /> */}
        <App />
      </ARCanvas>
    </div>
  )
}

ReactDOM.render(
  createCanvas(),
  document.getElementById('root4')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
